import { useLocation, useParams } from "react-router-dom";
import { NotFound } from "../../../components/NotFound/NotFound";
import { Profile } from "../../../components/Profile/Profile";
import { ModalPage } from "../../../components/ModalPage";

export const UserProfile = () => {
  const { state } = useLocation();
  const { userId } = useParams<{ userId: string }>();
  const parsedUserId = parseInt(userId || "");
  const fallback =
    (state as { back?: string } | null)?.back?.toString() || "/matches";
  if (isNaN(parsedUserId)) {
    return <NotFound />;
  }
  return (
    <ModalPage
      motionKey={`user-profile-${parsedUserId}`}
      fallback={fallback}
      bodyBg="bg.canvas"
    >
      <Profile userId={parsedUserId} />
    </ModalPage>
  );
};
